import React from 'react'
function ViewManPower({ item, data, open, onCancel }) {
  const displayItem = item || data;
  return (
    <div className=" w-full h-auto grid grid-cols-1  md:grid-cols-3">
    
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Designation</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.designation || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Category</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.category || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Type</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.type==0?"Own":"Rental"}</p>
      </div>

      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'> Quantity</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.quantity || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>No of Days</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.noOfDays || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Hours</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.hours || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Comments</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.comments || "-"}</p>
      </div>
      
    </div>
  )
}

export default ViewManPower